export default __webpack_public_path__ + "static/media/toggle-btn.ea301d7b.svg";